import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { JssNodeAbstract } from '../../model/jss-tree-abstract';
import { JssTreeObject } from '../../model/jss-tree-object';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-mat-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit, OnChanges {

   // public to access in template directly
   public _children: JssNodeAbstract[] = null;
   public _nodeName: string = null;
   public _nodeType: string = null;
   public _title: string = null;

   @Input() jssTreeObject: JssTreeObject = null;
   @Input() readonly = false;

   constructor() { }

   ngOnInit() {
   }

   ngOnChanges() {
      if (this.jssTreeObject) {
         this._nodeName = this.jssTreeObject.nodeName;
         this._nodeType = this.jssTreeObject.nodeType;
         this._children = this.jssTreeObject.children;

         // title
         if (this.jssTreeObject.showTitle) {
            this._title = this.jssTreeObject.hasTitle() ? this.jssTreeObject.title : this._nodeName;
         }
      }
   }

}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/json-form/material/layout/layout.component.ts